import { CloudUpload, X } from 'lucide-react';

export type UploadView = {
  key: string;
  filename: string;
  percent: number;
  state: 'uploading' | 'processing' | 'error';
  error?: string;
  controller: AbortController;
};

export function UploadTray({ uploads }: { uploads: UploadView[] }) {
  if (uploads.length === 0) return null;

  return (
    <section className="upload-tray" aria-label="Uploads" aria-live="polite">
      {uploads.map((upload) => (
        <div
          className={`upload-row${upload.state === 'error' ? ' is-error' : ''}`}
          key={upload.key}
        >
          <CloudUpload size={17} aria-hidden="true" />
          <div>
            <strong>{upload.filename}</strong>
            <span className="numeric">
              {upload.state === 'processing'
                ? 'Reading tags and artwork, then baking the waveform'
                : (upload.error ?? `${upload.percent}% uploaded`)}
            </span>
            <div className="upload-bar">
              <i style={{ width: `${upload.percent}%` }} />
            </div>
          </div>
          {upload.state === 'uploading' ? (
            <button
              type="button"
              className="icon-button"
              onClick={() => upload.controller.abort()}
              aria-label={`Cancel ${upload.filename}`}
            >
              <X size={15} />
            </button>
          ) : (
            <span />
          )}
        </div>
      ))}
    </section>
  );
}
